/**
 * @function
 * @param {string} str - The string to remove non-numeric characters from
 * @returns {string} - Returns the input string with all non-numeric characters removed
 * @example
 * removeNonNumericCharacters('abc123.45'); // '123.45'
 * removeNonNumericCharacters('1-2+3'); // '123'
 */
export default function removeNonNumericCharacters(str) {
  return str.replace(/[^\d.-]/g, '');
}
